import { Button } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import { AuthPageLayout } from "../components/AuthPageLayout";

interface ErrorPageProps {
  error?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const ErrorPage = ({ error, actionLabel, onAction }: ErrorPageProps) => {
  const { t } = useTranslation();

  const displayError = error || t("No valid session. Please use a valid portal access link.");

  return (
    <AuthPageLayout title={t("Access Error")} titleClassName="text-destructive">
      <Card.Body className="space-y-4 text-center">
        <p className="text-muted-foreground">{displayError}</p>
        <p className="text-sm text-muted-foreground">
          {t("If you believe this is an error, please contact your healthcare provider for a new access link.")}
        </p>
        {onAction && actionLabel && (
          <div className="pt-4">
            <Button variant="outline" onClick={onAction}>
              {actionLabel}
            </Button>
          </div>
        )}
      </Card.Body>
    </AuthPageLayout>
  );
};
